import script from "./EmojiTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiTrigger.vue?vue&type=script&setup=true&lang=js"

import "./EmojiTrigger.vue?vue&type=style&index=0&id=21e3b5d4&lang=scss"

const __exports__ = script;

export default __exports__